const environment = import.meta.env || {};

export const ADCASH_ZONE_ID = (
  environment.VITE_ADCASH_ZONE_ID || "gsyjugqzzvw"
).trim();
export const ADCASH_ENABLED =
  environment.VITE_ADCASH_ENABLED !== "false" && Boolean(ADCASH_ZONE_ID);

export const ADCASH_SIDE_BANNERS_ENABLED =
  ADCASH_ENABLED && environment.VITE_ADCASH_SIDE_BANNERS_ENABLED !== "false";

export const ADCASH_SIDE_ZONES = Object.freeze({
  left: Object.freeze({
    zoneId: (environment.VITE_ADCASH_LEFT_ZONE_ID || "12003714").trim(),
    width: 160,
    height: 600,
  }),
  right: Object.freeze({
    zoneId: (environment.VITE_ADCASH_RIGHT_ZONE_ID || "12018290").trim(),
    width: 120,
    height: 600,
  }),
});
